@if (showAppHeader$ | async) {
    <div class="on-top" [class.banner-active]="bannerVisible$ | async">
        @if (isSupportPage$ | async) {
            <app-support-outage-banner
                [class.banner-active]="bannerVisible$ | async"
                (bannerStateChange)="onBannerStateChange($event)"></app-support-outage-banner>
        }
        <app-header
            [class.support-banner-active]="bannerVisible$ | async"
            (openMobileProfile)="openMobileProfile()"></app-header>
    </div>
}

<main>
    <router-outlet (activate)="scrollToTop()"></router-outlet>
</main>

<app-back-to-top></app-back-to-top>
@if (showAppFooter$ | async) {
    <div class="footer-wrapper" [style.margin-top.px]="footerMarginTopPx$ | async">
        <app-footer></app-footer>
    </div>
}

<!--TODO: Need to fix. Causes UI to crash-->
<!-- <div *appMobile #mobileProfileContainer class="mobile-profile-container">
    <app-profile (closeMobileProfile)="closeMobileProfile()"></app-profile>
</div> -->
